import { useMemo } from 'react';
import { useProjectsForSelection } from '@/hooks/useProject';

export const CLOSED_PROJECT_STATUSES = new Set(['Completed', 'Cancelled', 'Closed']);

export type AllocationProjectOption = { value: string; label: string; closed: boolean };

/**
 * Project master options for HR allocation screens. Closed projects are kept for
 * filtering / "move from" but excluded from `assignable`.
 */
export function useAllocationProjects() {
  const query = useProjectsForSelection();

  const all: AllocationProjectOption[] = useMemo(
    () =>
      (query.data ?? []).map((p: any) => {
        const closed = CLOSED_PROJECT_STATUSES.has(String(p.project_status));
        return {
          value: p.id,
          label: `${p.project_number} — ${p.project_name}${closed ? ` (${p.project_status})` : ''}`,
          closed,
        };
      }),
    [query.data]
  );
  const assignable = useMemo(() => all.filter((o) => !o.closed), [all]);
  const labelById = useMemo(() => new Map(all.map((o) => [o.value, o.label])), [all]);

  return { all, assignable, labelById, isLoading: query.isLoading };
}
